var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.286,
    height: 16.818,
    viewBox: "0 0 15.286 16.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160375",
    "data-name": "Group 160375",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M6.032,16.5H16.754a1.532,1.532,0,0,1,1.532,1.532v5.361a1.532,1.532,0,0,1-1.532,1.532H6.032A1.532,1.532,0,0,1,4.5,23.393V18.032A1.532,1.532,0,0,1,6.032,16.5Z",
    transform: "translate(-4.5 -9.606)",
    fill: "none",
    stroke: "#111926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M10.5,9.893V6.83a3.83,3.83,0,0,1,7.659,0V9.893",
    transform: "translate(-7.437 -3)",
    fill: "none",
    stroke: "#111926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.3cefa87e7adf8ff9f9dbc0363ecd0d1f.svg";
export { ForwardRef as ReactComponent };